import agencyApi from 'api/agencyApi';
import agencyCommissionApi from 'api/agencyCommissionApi';
import store from 'app/store';
import { thunkGetInvestorList } from 'features/ManageInvestor/investorSlice';
import AppConstants from 'general/constants/AppConstants';
import ToastHelper from 'general/helpers/ToastHelper';
import { t } from 'i18next';
import { thunkGetAgencyList } from './agencySlice';
import Utils from 'general/utils/Utils';
import AppRoute from 'general/constants/AppRoute';
import Global from 'general/utils/Global';
import AppResource from 'general/constants/AppResource';
import { AppDialogHelper } from 'general/components/AppDialog';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import DialogChangeAgencyPasswordView from './components/DialogChangeAgencyPasswordView';
import AgencyHelper from 'features/Agency/agencyHelper';
import AgencyUIHelper from 'general/helpers/AgencyUIHelper';
import SetKPIView, { SetKPIViewHelper } from './components/SetKPIView';
import moment from 'moment';

const DealerHelper = {
  // ---- methods ----
  callApiGetAgencyList: (params) => {
    store.dispatch(thunkGetAgencyList({ params }));
  },

  callApiGetInvestorList: (params) => {
    store.dispatch(thunkGetInvestorList({ params }));
  },

  callApiGetAgencyDetail: async (agencyId, params) => {
    try {
      const res = await agencyApi.getAgencyDetail(agencyId, params);
      const { result, agency } = res;
      if (result === 'success' && agency) {
        return agency;
      }
      return {};
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiCreateAgency: async (params) => {
    try {
      const res = await agencyApi.createAgency(params);
      return res;
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiUpdateAgency: async (agencyId, params) => {
    try {
      const res = await agencyApi.updateAgency(agencyId, params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiDeleteAgency: async (agencyId) => {
    try {
      const res = await agencyApi.deleteAgency(agencyId);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiGetSubAgenciesList: async (agencyId, params) => {
    try {
      const res = await agencyApi.getSubAgenciesList(agencyId, params);
      const { result, total, subAgencies } = res;
      if (result === 'success' && total && subAgencies) {
        return { total, subAgencies };
      }
      return {};
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiGetAgencyTree: async (agencyId, params) => {
    try {
      const res = await agencyApi.getAgencyTree(agencyId, params);
      const { result, tree } = res;
      if (result === 'success' && tree) {
        return { tree };
      }
      return {};
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiCreateAgencyCommission: async (params) => {
    try {
      const res = await agencyApi.createAgencyCommission(params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiUpdateAgencyCommission: async (commissionId, params) => {
    try {
      const res = await agencyApi.updateAgencyCommission(commissionId, params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  isSuspended: (dl) => {
    return dl?.status == AppConstants.agencyStatus.suspended;
  },

  callApiCreateAgencyCommission: async (params) => {
    try {
      const res = await agencyCommissionApi.createAgencyCommission(params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
      return false;
    }
  },

  // callApiUpdateAgencyCommission: async (commissionId, params) => {
  //   if (commissionId) {
  //     try {
  //       console.log({ params });
  //       const res = await agencyCommissionApi.updateAgencyCommission(commissionId, params);
  //       const { result } = res;
  //       return result === 'success';
  //     } catch (error) {
  //       ToastHelper.showError(error?.response?.data?.reason);
  //     }
  //   }
  // },

  callApiDeleteAgencyCommission: async (commissionId) => {
    try {
      const res = await agencyCommissionApi.deleteAgencyCommission(commissionId);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiGetCommissionReport: async (params) => {
    try {
      const res = await agencyCommissionApi.getAgencyCommissionReport(params);
      const { result, commissions, total } = res;
      if (result === 'success' && commissions && total) {
        return { commissions, total };
      }
      return {};
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  checkPercentCommissionMode: (mode) => {
    return (
      mode === AppConstants.energyCommissionMode.percentInput ||
      mode === AppConstants.energyCommissionMode.percentOutput ||
      mode === AppConstants.energyCommissionMode.percentProfit
    );
  },

  formatCommissionMode: (mode, value) => {
    if (DealerHelper.checkPercentCommissionMode(mode)) return value / 100;
    return value;
  },

  reformatCommissionMode: (mode, value) => {
    if (DealerHelper.checkPercentCommissionMode(mode)) return value * 100;
    return value;
  },

  callApiRegisterAgencyAccount: async (params) => {
    try {
      const res = await agencyApi.registerAgencyAccount(params);
      const { result, reason, agency } = res;
      return { result, reason, agency };
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
      return false;
    }
  },

  callApiGetMonthlySale: async (params) => {
    try {
      const res = await agencyApi.getMonthlySale(params);
      return res;
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
      return false;
    }
  },

  callApiGetAgencyPaymentTransaction: async (params) => {
    try {
      const res = await agencyApi.getAgencyPaymentTransaction(params);
      return res;
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
      return false;
    }
  },

  callApiGetSaleKPIList: async (params) => {
    try {
      const res = await agencyApi.getSaleKPIList(params);
      const { result, saleKPIs, total } = res;
      if (result === 'success' && saleKPIs && total) {
        return { saleKPIs, total };
      }
      return {};
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiCreateSaleKPI: async (params) => {
    try {
      const res = await agencyApi.createSaleKPI(params);
      return res;
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiUpdateSaleKPI: async (kpiId, params) => {
    try {
      const res = await agencyApi.updateSaleKPI(kpiId, params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiDeleteSaleKPI: async (kpiId) => {
    try {
      const res = await agencyApi.deleteSaleKPI(kpiId);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  mergeRevenueIntoAgencies: (agencies, revenue) => {
    return agencies.map(agency => {
      const matchedRevenue = revenue.find(rev => rev.agencyId === agency.agencyId);
      return {
        ...agency,
        revenue: matchedRevenue ? matchedRevenue.revenue : 0
      };
    });
  },

  // lay mau trang thai dai ly
  getAgencyStatusColor: (status) => {
    switch (status) {
      case AppConstants.agencyStatus.normal:
        return 'success';
      case AppConstants.agencyStatus.signed:
        return 'info';
      case AppConstants.agencyStatus.suspended:
        return 'gray';
      case AppConstants.agencyStatus.deleted:
        return 'danger';
      case AppConstants.agencyStatus.registered:
        return 'info';
      case 'AVAILABLE':
        return 'success';
      default:
        return 'warning';
    }
  },

  // lay mau trang thai ban hang
  getSaleStatusColor: (status) => {
    switch (status) {
      case AppConstants.saleStatus.ordered:
        return 'info';
      case AppConstants.saleStatus.shipping:
        return 'warning';
      case AppConstants.saleStatus.installing:
        return 'danger';
      case AppConstants.saleStatus.installed:
        return 'danger';
      case AppConstants.saleStatus.completed:
        return 'success';
      default:
        return 'warning';
    }
  },

  // lay mau trang thai hoa don tien dien
  getLandownerElectricityBillColor: (status) => {
    switch (status) {
      case AppConstants.energyBillStatus.validated:
        return 'success';
      case AppConstants.energyBillStatus.pending:
        return 'warning';
      default:
        return 'warning';
    }
  },

  // filter trang thai dai ly
  filterStatusOptions: () => {
    return [
      { name: t('all'), value: '' },
      {
        name: t('agencyStatus_' + AppConstants.agencyStatus.normal),
        value: AppConstants.agencyStatus.normal,
      },
      {
        name: t('agencyStatus_' + AppConstants.agencyStatus.signed),
        value: AppConstants.agencyStatus.signed,
      },
      {
        name: t('agencyStatus_' + AppConstants.agencyStatus.suspended),
        value: AppConstants.agencyStatus.suspended,
      },
      {
        name: t('agencyStatus_' + AppConstants.agencyStatus.deleted),
        value: AppConstants.agencyStatus.deleted,
      },
      {
        name: t('agencyStatus_' + AppConstants.agencyStatus.registered),
        value: AppConstants.agencyStatus.registered,
      },
    ];
  },

  filterStatusOptionsLandlord: () => {
    return [
      { name: t('all'), value: '' },
      {
        name: t('agencyStatus_' + AppConstants.agencyStatus.normal),
        value: AppConstants.agencyStatus.normal,
      },
      {
        name: t('agencyStatus_' + AppConstants.agencyStatus.suspended),
        value: AppConstants.agencyStatus.suspended,
      },
      {
        name: t('agencyStatus_' + AppConstants.agencyStatus.deleted),
        value: AppConstants.agencyStatus.deleted,
      },
      {
        name: t('agencyStatus_' + AppConstants.agencyStatus.registered),
        value: AppConstants.agencyStatus.registered,
      },
    ];
  },

  // filter trang thai ban hang
  filterSaleStatusOptions: () => {
    return [
      { name: t('all'), value: '' },
      {
        name: t('saleStatus_' + AppConstants.saleStatus.ordered),
        value: AppConstants.saleStatus.ordered,
      },
      {
        name: t('saleStatus_' + AppConstants.saleStatus.shipping),
        value: AppConstants.saleStatus.shipping,
      },
      {
        name: t('saleStatus_' + AppConstants.saleStatus.installing),
        value: AppConstants.saleStatus.installing,
      },
      {
        name: t('saleStatus_' + AppConstants.saleStatus.installed),
        value: AppConstants.saleStatus.installed,
      },
      {
        name: t('saleStatus_' + AppConstants.saleStatus.completed),
        value: AppConstants.saleStatus.completed,
      },
    ];
  },

  // filter loai dai ly
  filterAgencyTypeOptions: () => {
    return [
      { name: t('all'), value: '' },
      {
        name: t('accountType_' + AppConstants.accountType.individual),
        value: AppConstants.accountType.individual,
      },
      {
        name: t('accountType_' + AppConstants.accountType.organization),
        value: AppConstants.accountType.organization,
      },
    ];
  },

  // filter agency role
  filterAgencyRoleOptions: () => {
    return [
      {
        name: t('agencyRoleDropdownTitle_' + AppConstants.userAgencyType.investor),
        value: AppConstants.userAgencyType.investor,
      },
      {
        name: t('agencyRoleDropdownTitle_' + AppConstants.userAgencyType.group),
        value: AppConstants.userAgencyType.group,
      },
      {
        name: t('agencyRoleDropdownTitle_' + AppConstants.userAgencyType.landlord),
        value: AppConstants.userAgencyType.landlord,
      },
    ];
  },

  formatDealerCode: (dealerId) => {
    if (!dealerId) return;
    const prefix = 'DL';
    const formattedId = dealerId;
    return dealerId;
  },

  formatInvestorCode: (investorId) => {
    const prefix = 'NĐT';
    const formattedId = investorId;
    return investorId;
  },

  navigateToParentAgency: (parentAgency) => {
    if (!parentAgency) return;
    if (parentAgency?.primaryRole === AppConstants.userAgencyType.sale)
      Utils.openInNewTab(`${AppRoute.saleList}/${parentAgency?.agencyId}`);
    else if (parentAgency?.primaryRole === AppConstants.userAgencyType.investor)
      Utils.openInNewTab(`${AppRoute.investorList}/${parentAgency?.agencyId}`);
    else if (parentAgency?.primaryRole === AppConstants.userAgencyType.group)
      Utils.openInNewTab(`${AppRoute.groupList}/${parentAgency?.agencyId}`);
    else
      Utils.openInNewTab(`${AppRoute.landlordList}/${parentAgency?.agencyId}`);
  },

  getAgencyFilter: (agencyRole) => {
    switch (agencyRole) {
      case AppConstants.userAgencyType.sale:
        return Global.g_filterDealerList;
      case AppConstants.userAgencyType.investor:
        return Global.g_filterInvestorList;
      case AppConstants.userAgencyType.group:
        return Global.g_filterInvestorGroupList;
      case AppConstants.userAgencyType.landlord:
        return Global.g_filterLandownerList;
    }
  },

  formatAgencyCustomDropdown: (agency) => {
    return {
      name: agency.name,

    }
  },

  formatAgencyType: (type) => {
    switch (type) {
      case AppConstants.userAgencyType.sale:
        return 'đại lý';
      case AppConstants.userAgencyType.investor:
        return 'NĐT';
      case AppConstants.userAgencyType.group:
        return 'NĐT';
      case AppConstants.userAgencyType.landlord:
        return 'chủ mặt bằng';
      case AppConstants.userAgencyType.chargepoint:
        return 'đối tác';
    }
  },

  getAgencyLevel: (level) => {
    switch (level) {
      case 1:
        return AppConstants.agencyLevel.level1;
      case 2:
        return AppConstants.agencyLevel.level2;
      case 3:
        return AppConstants.agencyLevel.level3;
      case 4:
        return AppConstants.agencyLevel.level4;
      case 5:
        return AppConstants.agencyLevel.level5;
      default:
        return AppConstants.agencyLevel.level0;
    }
  },

  filterAgencyLevelOptions: () => {
    return [
      { name: t('all'), value: '' },
      {
        name: AppConstants.agencyLevel.level1,
        value: 1,
      },
      {
        name: AppConstants.agencyLevel.level2,
        value: 2,
      },
      {
        name: AppConstants.agencyLevel.level3,
        value: 3,
      },
      {
        name: AppConstants.agencyLevel.level4,
        value: 4,
      },
      {
        name: AppConstants.agencyLevel.level5,
        value: 5,
      },
    ];
  },

  genderOptions: () => {
    return [
      {
        name: t('gender_MALE'),
        value: 'MALE',
      },
      {
        name: t('gender_FEMALE'),
        value: 'FEMALE',
      },
    ];
  },

  // dung hoat dong
  handleStopAgency: (row, onCompleted = () => { }) => {
    AppDialogHelper.show(
      'Ngừng hoạt động',
      `Bạn có chắc muốn ngừng hoạt động ${DealerHelper.formatAgencyType(row?.primaryRole)} <span class="font-weight-boldest text-gray-800">${row?.name}</span> không?`,
      [
        {
          title: 'Hủy bỏ',
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
        {
          title: 'Ngừng hoạt động',
          type: 'negative',
          onClick: async () => {
            AppDialogHelper.hide();
            const isSuccess = await DealerHelper.callApiUpdateAgency(row?.agencyId, {
              status: 'SUSPENDED',
            });
            if (isSuccess) {
              ToastHelper.showSuccess(`Ngừng hoạt động ${DealerHelper.formatAgencyType(row?.primaryRole)} thành công`);
              onCompleted();
            } else {
              ToastHelper.showError(`Ngừng hoạt động ${DealerHelper.formatAgencyType(row?.primaryRole)} không thành công`);
            }
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogStopAgency
    );
  },

  // khoi phuc hoạt dong
  handleActiveAgency: (row, onCompleted = () => { }) => {
    AppDialogHelper.show(
      'Khôi phục hoạt động',
      `Bạn có chắc muốn khôi phục hoạt động ${DealerHelper.formatAgencyType(row?.primaryRole)} <span class="font-weight-boldest text-gray-800">${row?.name}</span> không?`,
      [
        {
          title: 'Hủy bỏ',
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
        {
          title: 'Khôi phục',
          type: 'success',
          onClick: async () => {
            AppDialogHelper.hide();
            const isSuccess = await DealerHelper.callApiUpdateAgency(row?.agencyId, {
              status: 'NORMAL',
            });
            if (isSuccess) {
              ToastHelper.showSuccess(`Khôi phục ${DealerHelper.formatAgencyType(row?.primaryRole)} thành công`);
              onCompleted();
            } else {
              ToastHelper.showError(`Khôi phục ${DealerHelper.formatAgencyType(row?.primaryRole)} không thành công`);
            }
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogActiveAgency
    );
  },

  handleDeleteAgency: (row, onCompleted = () => { }) => {
    AppDialogHelper.show(
      `Xoá ${DealerHelper.formatAgencyType(row?.primaryRole)}`,
      `Bạn thực sự muốn xoá ${DealerHelper.formatAgencyType(row?.primaryRole)} <span class="font-weight-boldest text-gray-800">${row?.name}</span>?`,
      [
        {
          title: 'Hủy bỏ',
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
        {
          title: 'Xóa',
          type: 'negative',
          onClick: async () => {
            AppDialogHelper.hide();
            const isSuccess = await DealerHelper.callApiDeleteAgency(row?.agencyId);
            if (isSuccess) {
              ToastHelper.showSuccess(`Xoá ${DealerHelper.formatAgencyType(row?.primaryRole)} thành công`);
              onCompleted();
            } else {
              console.log(`Xóa ${DealerHelper.formatAgencyType(row?.primaryRole)} thất bại`);
            }
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogDeleteVehicle
    );
  },

  // phe duyet dai ly
  handleAcceptAgency: (row, onCompleted = () => { }) => {
    AppDialogHelper.show(
      `Kích hoạt tài khoản`,
      `Bạn có chắc muốn kích hoạt tài khoản ${DealerHelper.formatAgencyType(row?.primaryRole)} <span class="font-weight-boldest text-gray-800">${row?.name}</span> không?`,
      [
        {
          title: 'Hủy bỏ',
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
        {
          title: 'Kích hoạt',
          type: 'success',
          onClick: async () => {
            AppDialogHelper.hide();
            const isSuccess = await DealerHelper.callApiUpdateAgency(row?.agencyId, {
              status: AppConstants.agencyStatus.normal,
            });
            if (isSuccess) {
              ToastHelper.showSuccess(`Kích hoạt tài khoản ${DealerHelper.formatAgencyType(row?.primaryRole)} thành công`);
              onCompleted();
            } else {
              ToastHelper.showError(`Kích hoạt tài khoản ${DealerHelper.formatAgencyType(row?.primaryRole)} thất bại`);
            }
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogAcceptAgency
    );
  },

  // filter nguoi tao
  filterCreatedByOptions: () => {
    return [
      { name: t('all'), value: '' },
      {
        name: t('createdBy_' + AppConstants.createdBy.me),
        value: AppConstants.createdBy.me,
      },
      {
        name: t('createdBy_' + AppConstants.createdBy.others),
        value: AppConstants.createdBy.others,
      },
      {
        name: t('createdBy_' + AppConstants.createdBy.self),
        value: AppConstants.createdBy.self,
      },
    ];
  },

  // cap dai ly
  filterLevelOptions: (agencyType, agencyDeepLevel = 0) => {
    return [
      { name: t('all'), value: '' },
      {
        name: 'Tài khoản của bạn',
        value: agencyDeepLevel + 1,
      },
      {
        name: agencyType === 'SALE'
          ? 'Đại lý cấp 1 của bạn'
          : agencyType === 'CHARGEPOINT'
            ? 'Đối tác cấp 1 của bạn'
            : 'Nhà đầu tư cấp 1 của bạn',
        value: agencyDeepLevel + 2,
      },
    ];
  },

  handleReformatCommission: (commission) => {
    let accumulatedDiscount = 0;
    const formattedCommission = commission.map((item, index) => {
      if (index === 0) {
        accumulatedDiscount = Number(item?.discount);
        return item;
      }

      const currentDiscount = Number(item?.discount);
      const prevDiscount = Number(commission[index - 1]?.discount) || 0;
      accumulatedDiscount = currentDiscount - prevDiscount;
      const newDiscount = String(accumulatedDiscount);

      return { ...item, discount: newDiscount };
    });

    return formattedCommission;
  },

  checkHasEditPermission: (agency, parentAgency, userAgency) => {
    if (userAgency?.primaryRole === 'SALE') {
      if (userAgency?.deepLevel < 3) return true;
      const ids = [
        agency?.agencyId,
        agency?.parentAgencyId,
        parentAgency?.parentAgencyId
      ];
      return ids.includes(userAgency?.agencyId) && parentAgency?.primaryRole === 'SALE';
    } else {
      const ids = [
        agency?.agencyId,
        agency?.parentAgencyId,
      ];
      return ids.includes(userAgency?.agencyId);
    }
  },

  checkSaleHasEditPermission: (agency, userAgency) => {
    if (userAgency?.primaryRole === 'SALE') {
      return agency?.deepLevel >= userAgency?.deepLevel;
    } else {
      const ids = [
        agency?.agencyId,
        agency?.parentAgencyId,
      ];
      return ids.includes(userAgency?.agencyId);
    }
  },

  showDialogChangePassword: (agency, onDone) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        title="Đặt lại mật khẩu"
        contentEl={<>Thay đổi mật khẩu đăng nhập cho tài khoản {t(`abbAgencyRole_${agency?.primaryRole}`)}</>}
        iconEl={<img src={AppResource.images.dialogIcons.dialogChangePassword} />}
        bodyEl={
          <DialogChangeAgencyPasswordView
            agency={agency}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onDone={() => {
              AppCustomDialogHelper.hide();
              if (onDone) {
                onDone();
              }
            }}
          />
        }
        removeFooter={true}
      />,
      'md',
      false,
      true
    );
  },

  showDialogCreateContract: (row) => {
    AppDialogHelper.show(
      `Không thể tạo đơn hàng cho ${AgencyHelper.Utils.getShortAgencyRoleName(row?.primaryRole)?.toLowerCase()}`,
      `${AgencyHelper.Utils.getShortAgencyRoleName(row?.primaryRole)} không thể tạo đơn hàng do chưa ký hợp đồng CTV với nhà điều hành.`,
      [
        {
          title: 'Hủy bỏ',
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
        {
          title: 'Tạo hợp đồng',
          type: 'primary',
          onClick: async () => {
            AppDialogHelper.hide();
            AgencyHelper.UI.showDialogConfirmCreateContractWithAgency(row, () => { });
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogError
    );
  },

  // xem tep dinh kem
  handleShowFile: (fileList) => {
    AppCustomDialogHelper.show(
      'Tệp đính kèm',
      <>
        {AgencyUIHelper.buildShowFileDialog(fileList, () => { AppCustomDialogHelper.hide() })}
      </>
    );
  },

  handleShowImage: (title, fileUrl) => {
    const isVideo = /\.(mp4|webm|ogg|mov)$/i.test(fileUrl);

    AppDialogHelper.show(
      <div style={{ fontSize: 20, textAlign: 'center', marginBottom: 16 }}>
        {title}
      </div>,
      '',
      [],
      false,
      null,
      <div className="d-flex justify-content-center">
        {isVideo ? (
          <video
            src={fileUrl}
            controls
            autoPlay={false}
            style={{ maxWidth: '100%', maxHeight: '80vh', width: 600, borderRadius: 8 }}
          />
        ) : (
          <img
            src={fileUrl}
            alt={title}
            style={{ maxWidth: '100%', maxHeight: '80vh', width: 600, borderRadius: 8, objectFit: 'contain' }}
          />
        )}
      </div>
    );
  },

  // lay ten trang thai sale kpi
  getSaleKpiStatusName: (status) => {
    switch (status) {
      case ChargeConstants.TutorialStatus.NORMAL:
        return 'Hoạt động';
      case ChargeConstants.TutorialStatus.DELETED:
        return 'Đang ẩn';
      default:
        return '';
    }
  },
  // lay mau sac cua trang thai sale kpi
  getSaleKpiStatusColor: (status) => {
    switch (status) {
      case ChargeConstants.TutorialStatus.NORMAL:
        return 'success';
      case ChargeConstants.TutorialStatus.DELETED:
        return 'info';
      default:
        return '';
    }
  },

  // set KPI thang
  setMonthKPI: (row, onCompleted = () => { }) => {
    AppDialogHelper.show(
      'Thiết lập KPI tháng',
      `Nhập số tiền để thiết lập mục tiêu KPI tháng 
      <span class="font-weight-boldest text-gray-800">${moment().format('MM/YYYY')}</span> 
      cho đại lý <span class="font-weight-boldest text-gray-800">${row?.name}</span>`,
      [
        {
          title: 'Bỏ qua',
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
        {
          title: 'Lưu lại',
          type: 'positive',
          onClick: async () => {
            SetKPIViewHelper.onSubmit();
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogSetKPI,
      <SetKPIView
        item={row}
        onSubmit={async (values) => {
          const currentMonth = moment().format('YYYY-MM');

          const kpiMap = {
            INVESTOR: values.saleKPI,
            GROUP: values.packageKPI,
            CHARGEPOINT: values.chargePointKPI,
          };

          const handleKPIUpdate = async (orderType, newValue) => {
            const kpi = row?.kpis?.find(k => k?.orderType === orderType && k?.month === currentMonth);

            if (kpi?.kpiValue === newValue) return true;

            if (kpi?.kpiId) {
              return DealerHelper.callApiUpdateSaleKPI(kpi.kpiId, { kpiValue: newValue });
            }

            return DealerHelper.callApiCreateSaleKPI({ agencyId: row?.agencyId, kpiValue: newValue, orderType, month: currentMonth });
          };

          const results = await Promise.all([
            handleKPIUpdate('INVESTOR', kpiMap.INVESTOR),
            handleKPIUpdate('GROUP', kpiMap.GROUP),
            handleKPIUpdate('CHARGEPOINT', kpiMap.CHARGEPOINT),
          ]);

          if (results.every(Boolean)) {
            ToastHelper.showSuccess('Thiết lập KPI tháng cho đại lý thành công');
            onCompleted();
            AppDialogHelper.hide();
          } else {
            ToastHelper.showError('Thiết lập KPI tháng cho đại lý thất bại');
          }
        }}

        isDefaultKPI={false}
      />
    );
  },

  // set KPI mac dinh
  setDefaultKPI: (row, onCompleted = () => { }) => {
    AppDialogHelper.show(
      'Thiết lập KPI mặc định',
      `Nhập số tiền để đặt mục tiêu KPI mặc định hàng tháng cho đại lý [Tên đại lý]. Hệ thống sẽ tự động áp dụng KPI này vào đầu mỗi tháng.`,
      [
        {
          title: 'Bỏ qua',
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
        {
          title: 'Lưu lại',
          type: 'positive',
          onClick: async () => {
            SetKPIViewHelper.onSubmit();
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogSetDefaultKPI,
      <SetKPIView
        item={row}
        onSubmit={async (values) => {
          const isSuccess = await DealerHelper.callApiUpdateAgency(row?.agencyId, {
            saleKPI: values.saleKPI,
            packageKPI: values.packageKPI,
            chargePointKPI: values.chargePointKPI,
          });
          if (isSuccess) {
            ToastHelper.showSuccess('Thiết lập KPI mặc định cho đại lý thành công');
            onCompleted();
            AppDialogHelper.hide();
          } else {
            ToastHelper.showError('Thiết lập KPI mặc định cho đại lý thất bại');
          }
        }}
      />
    );
  },
};

export default DealerHelper;
